import { useState } from "react";
import { useNavigate, useLoaderData } from "react-router-dom";
import { createMember, updateMember } from "../../../api/cms";

export default function AdminMemberForm() {
  const existing = useLoaderData();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", link: "", logo: "", ...existing });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      if (existing?.id) {
        await updateMember(existing.id, form);
      } else {
        await createMember(form);
      }
      navigate("/admin/members");
    } catch {
      setError("Failed to save. Check your API key and try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-lg">
      <h1 className="text-2xl font-bold mb-6">{existing?.id ? "Edit member" : "Add member"}</h1>
      <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6 flex flex-col gap-4">
        <label className="flex flex-col gap-1 text-sm font-medium">
          Name
          <input className="border border-gray-300 rounded px-3 py-2 font-normal focus:outline-none focus:ring-2 focus:ring-bahyellow" value={form.name} onChange={set("name")} required />
        </label>
        <label className="flex flex-col gap-1 text-sm font-medium">
          Website URL
          <input className="border border-gray-300 rounded px-3 py-2 font-normal focus:outline-none focus:ring-2 focus:ring-bahyellow" value={form.link} onChange={set("link")} type="url" required />
        </label>
        <label className="flex flex-col gap-1 text-sm font-medium">
          Logo URL (S3 path or full URL)
          <input className="border border-gray-300 rounded px-3 py-2 font-normal focus:outline-none focus:ring-2 focus:ring-bahyellow" value={form.logo} onChange={set("logo")} required />
        </label>
        {form.logo && <img src={form.logo} alt="Preview" className="h-12 object-contain self-start" />}
        {error && <p className="text-red-500 text-sm">{error}</p>}
        <div className="flex gap-3 mt-2">
          <button type="submit" disabled={saving} className="bg-bahyellow rounded px-4 py-2 text-sm font-semibold hover:opacity-90 disabled:opacity-50">
            {saving ? "Saving…" : "Save"}
          </button>
          <button type="button" onClick={() => navigate("/admin/members")} className="rounded px-4 py-2 text-sm border border-gray-300 hover:bg-gray-50">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}
